import $ from 'jquery';

// Import media
import delayScheduleBannerImg from './img/delay-banner.svg';

// Import dependencies
import { html, render } from 'lit';

import { canManageSchedule } from '@builder-legacy/item/schedule/utilities';

import Field from '../field';

import Modal from '../common/modal.js';

import Actions from './actions.js';

import Tokens from '../tokens';

class ItemHeaderAsync {
	buttonContainer;

	button;

	buttonIcon;

	removeButton;

	asyncModeField;

	asyncModeHTML;

	delayNumberField;

	delayNumberHTML;

	delayUnitField;

	delayUnitHTML;

	scheduleDateField;

	scheduleDateHTML;

	scheduleTimeField;

	scheduleTimeHTML;

	scheduleNoticeHTML;

	modal;

	/**
	 * Create item actions
	 *
	 * @since 0.5
	 * @return jQuery DOM element with the item actions
	 */

	constructor( itemType, integrationID, itemCode, itemId ) {
		// Make sure it's an action
		if ( itemType !== 'action' ) {
			return;
		}

		if ( UncannyAutomator._site.automator.version_pro.startsWith( '2' ) ) {
			return null;
		}

		// Get the item
		this.item = UncannyAutomator._core.recipe.item.getItem( itemType, itemId );

		if ( ! _uo.utility.isDefined( this.item ) ) {
			return;
		}

		// If the item is inside a loop, don't add the delay button
		if ( UncannyAutomator._core.recipe.item.loop.getParentLoop( itemId ) ) {
			return;
		}

		this.itemType = itemType;
		this.integrationID = integrationID;
		this.itemCode = itemCode;
		this.itemId = itemId;

		this.fabricatedMeta = {
			async_mode: '',
			async_delay_number: '',
			async_delay_unit: '',
			async_schedule_time: '',
			async_schedule_date: '',
			async_sentence: '',
			async_custom: ''
		}
		
		if ( _uo.utility.isDefined( this.item.miscellaneous.delay_schedule ) ) {
			const fromNewFormat = this.item.miscellaneous.delay_schedule;

			this.fabricatedMeta.async_mode          = _uo.utility.isDefined( fromNewFormat.MODE )          ? fromNewFormat.MODE.value : '';
			this.fabricatedMeta.async_delay_number  = _uo.utility.isDefined( fromNewFormat.DELAY_VALUE )   ? fromNewFormat.DELAY_VALUE.value : '';
			this.fabricatedMeta.async_delay_unit    = _uo.utility.isDefined( fromNewFormat.DELAY_UNIT )    ? fromNewFormat.DELAY_UNIT.value : '';
			this.fabricatedMeta.async_schedule_time = _uo.utility.isDefined( fromNewFormat.SCHEDULE_TIME ) ? fromNewFormat.SCHEDULE_TIME.value : '';
			this.fabricatedMeta.async_schedule_date = _uo.utility.isDefined( fromNewFormat.SCHEDULE_DATE ) ? fromNewFormat.SCHEDULE_DATE.value : '';
			this.fabricatedMeta.async_custom = _uo.utility.isDefined( fromNewFormat.CUSTOM_VALUE ) ? fromNewFormat.CUSTOM_VALUE.value : '';

			if ( this.fabricatedMeta.async_mode === 'delay' ) {
				this.fabricatedMeta.async_sentence = this.delaySentence(
					this.fabricatedMeta.async_delay_number,
					this.fabricatedMeta.async_delay_unit
				);
			}

			if ( this.fabricatedMeta.async_mode === 'schedule' ) {
				this.fabricatedMeta.async_sentence = this.scheduleSentence(
					this.fabricatedMeta.async_schedule_time,
					this.fabricatedMeta.async_schedule_date
				);
			}

			if ( this.fabricatedMeta.async_mode === 'custom' ) {
				// Render tokens
				this.fabricatedMeta.async_sentence = ( 
					new Tokens( 'closure', 'text', { forceShowBothLoopableAndNonLoopable: true } ) 
				).renderTextWithTokens( this.fabricatedMeta.async_custom ).outerHTML;
			}
		}

		this.asyncMode = this.fabricatedMeta.async_mode;

		this.createAsyncButton();
	}

	hasSchedule() {
		if ( ! this.asyncMode ) {
			return false;
		}

		if ( this.asyncMode == 'delay' ) {
			return this.fabricatedMeta.async_delay_number && this.fabricatedMeta.async_delay_unit;
		}

		if ( this.asyncMode == 'schedule' ) {
			return this.fabricatedMeta.async_schedule_time && this.fabricatedMeta.async_schedule_date;
		}

		if ( this.asyncMode == 'custom' ) {
			return ! _uo.utility.isEmpty( this.fabricatedMeta.async_custom );
		}

		return false;
	}

	getButtonText() {
		const addProTag = ! UncannyAutomatorBackend._site.automator.is_pro_active ? '<uo-pro-tag size="extra-small"></uo-pro-tag>' : '';

		if ( this.hasSchedule() ) {
			let text = {
				delay: _uo.utility.escHTML( wp.i18n.__( 'Delay', 'uncanny-automator' ) ),
				schedule: _uo.utility.escHTML( wp.i18n.__( 'Schedule', 'uncanny-automator' ) ),
				custom: _uo.utility.escHTML( wp.i18n.__( 'Use a token/custom value', 'uncanny-automator' ) ),
			}[ this.asyncMode ];
			text += ' ';

			if ( this.asyncMode == 'custom' ) {
				text = '';
			}

			if ( UncannyAutomatorBackend._site.automator.is_pro_active ) {
				text += `${ this.fabricatedMeta.async_sentence }`;
			} else {
				text += `<strike>${ this.fabricatedMeta.async_sentence }</strike>`;
			}

			return text + ` ${ addProTag }`;
		}
		
		return _uo.utility.escHTML( wp.i18n.__( 'Delay', 'uncanny-automator' ) ) + ` ${ addProTag }`;
	}

	createAsyncButton() {
		// Create wrapper
		this.buttonContainer = document.createElement( 'div' );
		this.buttonContainer.classList.add( 'item-async' );

		// Add class with the selected async type
		if ( this.asyncMode ) {
			this.buttonContainer.classList.add( `item-async--${ this.asyncMode }` );
		}

		// Create button
		this.buttonContainer.innerHTML = `
			<uo-button
				size="extra-small"
				color="secondary"
			>
				<uo-icon id="clock"></uo-icon> ${ this.getButtonText() }
			</uo-button>
		`;

		this.buttonContainer = $( this.buttonContainer );
		this.button = this.buttonContainer.find( 'uo-button' );

		if ( canManageSchedule() ) { 

			if ( this.hasSchedule() ) {
				this.createRemoveButton();
			}

			// Listen clicks to the open button
			this.button.on( 'click', () => {
				if ( ! this.buttonContainer.hasClass( 'disabled' ) ) {
					this.showModal();
				}
			} );

			this.buttonContainer.on( 'automator:asyncButton:maybeDisable', ( e, disable ) => {
				const buttonContainer = $( e.currentTarget );

				if ( disable ) {
					buttonContainer.attr( 'uap-tooltip', wp.i18n.__( 'Please save the action first', 'uncanny-automator' ) );

					this.button.prop( 'disabled', true );
				} else {
					this.button.prop( 'disabled', false );
					buttonContainer.removeAttr( 'uap-tooltip', false );
				}
			} );

		} else {
			// Open link on click
			this.buttonContainer.get(0).addEventListener( 'click', () => {
				this.handleCreateUpsellDialog();
			} );
		}

		this.$button = this.buttonContainer.get(0);
	}

	enable() {
		this.button.removeAttr( 'uap-tooltip' );
		this.button.removeAttr( 'disabled' );
	}

	createRemoveButton() {
		this.removeButton = $( '<span/>', { class: 'async-remove' } );
		this.removeButtonIcon = $( '<uo-icon/>', { id: 'xmark' } );

		this.removeButton.text( wp.i18n.__( 'Remove', 'uncanny-automator' ) );
		this.removeButton.on( 'click', () => {
			this.removeSchedule();
		} );
		this.removeButton.prepend( this.removeButtonIcon );
		this.buttonContainer.append( this.removeButton );
	}

	createModalContent() {
		// Create the content for the modal
		const modalContent = $( `<div/>`, { class: 'async-action-modal' } );

		this.asyncModeHTML = this.createAsyncModeHTML();

		jQuery( this.asyncModeHTML.find( '.form-radio__container' ).get(0) ).after( this.createDelayOptions() );
		jQuery( this.asyncModeHTML.find( '.form-radio__container' ).get(1) ).after( this.createScheduleOptions() );
		jQuery( this.asyncModeHTML.find( '.form-radio__container' ).get(2) ).after( this.createCustomOptions() );

		this.attachModeChangeEvent();

		// Add the field
		modalContent.append( this.asyncModeHTML );

		if ( this.hasSchedule() ) {
			const modalNoticeHTML = $( '<div/>', { class: 'async-notice async-notice__blue' } );
			const modalNoticeIcon = $( '<uo-icon/>', { id: 'triangle-exclamation' } );
			modalNoticeHTML.append( modalNoticeIcon );
			modalNoticeHTML.append( wp.i18n.__( 'Note: Changes will not affect previously delayed or scheduled actions.', 'uncanny-automator' ) );
			modalContent.append( modalNoticeHTML );
		}

		return modalContent;
	}

	showModal() {
		let confirmButtonText = _uo.utility.escHTML( wp.i18n.__( 'Set delay', 'uncanny-automator' ) );

		if ( this.hasSchedule() && this.asyncMode == 'schedule' ) {
			confirmButtonText = _uo.utility.escHTML( wp.i18n.__( 'Schedule', 'uncanny-automator' ) );
		}

		// Show a modal
		this.modal = new Modal(
			{
				title: _uo.utility.escHTML( wp.i18n.__( 'Delay or schedule this action', 'uncanny-automator' ) ),
				content: this.createModalContent(),
				buttons: {
					cancel: _uo.utility.escHTML( wp.i18n._x( 'Cancel', 'Verb', 'uncanny-automator' ) ),
					confirm: confirmButtonText,
				},
			},
			{
				size: 'large',
				customClass: 'async-action',
			}
		);

		this.modalEvents();
	}

	modalEvents() {
		this.modal.setEvents( {
			afterSetEvents: () => {
				this.modal.show();
			},
			onConfirm: () => {
				this.submitModal();
			},
			afterHide: () => {
				this.modal.destroy();
			},
		} );
	}

	submitModal() {
		const elements = this.modal.getElements();
		const confirmButton = elements.modal.box.buttons.confirm;

		// Add loading class to button
		confirmButton.addClass( 'uap-btn--loading' ).prop( 'disabled', true );

		if ( ! this.validateForm().isValid ) {
			confirmButton.removeClass( 'uap-btn--loading' ).prop( 'disabled', false );
			return;
		}

		const asyncMode = this.asyncModeField.getValue();
		const delayNumber = this.delayNumberField.getValue();
		const delayUnit = this.delayUnitField.getValue();
		const scheduleTime = this.scheduleTimeField.getValue();
		const scheduleDate = this.scheduleDateField.getValue();
		const customValue = this.customTokenField.getValue();

		let sentence;

		if ( asyncMode == 'delay' ) {
			sentence = this.delaySentence( this.delayNumberField.getValue(), this.delayUnitField.getValue() );
		} 
		
		if ( asyncMode == 'schedule' ) {
			sentence = this.scheduleSentence( this.scheduleDateField.getValue(), this.scheduleTimeField.getValue() );
		}

		if ( asyncMode == 'custom' ) {
			sentence = 'Custom';
		}

		this.saveSchedule( asyncMode, delayNumber, delayUnit, scheduleTime, scheduleDate, sentence, customValue );
	}

	delaySeconds() {
		const delayUnit = this.delayUnitField.getValue();
		const delayNumber = this.delayNumberField.getValue();
		let multiplier;

		switch ( delayUnit ) {
			case 'seconds':
				multiplier = 1;
				break;
			case 'minutes':
				multiplier = 60;
				break;
			case 'hours':
				multiplier = 60 * 60;
				break;
			case 'days':
				multiplier = 60 * 60 * 24;
				break;
			case 'years':
				multiplier = 60 * 60 * 24 * 365;
				break;
			default:
				multiplier = 1;
				break;
		}

		return delayNumber * multiplier;
	}

	delaySentence( number, unit ) {
		if ( number == 1 ) {
			unit = unit.slice( 0, -1 );
		}

		return `${ number } ${ {
			second: _uo.utility.escHTML( wp.i18n.__( 'second', 'uncanny-automator' ) ),
			seconds: _uo.utility.escHTML( wp.i18n.__( 'Seconds', 'uncanny-automator' ) ),
			minute: _uo.utility.escHTML( wp.i18n.__( 'minute', 'uncanny-automator' ) ),
			minutes: _uo.utility.escHTML( wp.i18n.__( 'Minutes', 'uncanny-automator' ) ),
			hour: _uo.utility.escHTML( wp.i18n.__( 'hour', 'uncanny-automator' ) ),
			hours: _uo.utility.escHTML( wp.i18n.__( 'Hours', 'uncanny-automator' ) ),
			day: _uo.utility.escHTML( wp.i18n.__( 'day', 'uncanny-automator' ) ),
			days: _uo.utility.escHTML( wp.i18n.__( 'Days', 'uncanny-automator' ) ),
			year: _uo.utility.escHTML( wp.i18n.__( 'year', 'uncanny-automator' ) ),
			years: _uo.utility.escHTML( wp.i18n.__( 'Years', 'uncanny-automator' ) ),
		}[ unit ].toLowerCase() }`;
	}

	scheduleSeconds() {
		return Date.parse( `${ this.scheduleDateField.getValue() } ${ this.scheduleTimeField.getValue() }` );
	}

	scheduleSentence( time, date ) {
		return `${ time } @ ${ date }`;
	}

	saveSchedule(
		asyncMode,
		delayNumber = null,
		delayUnit = null,
		scheduleTime = null,
		scheduleDate = null,
		sentence = null,
		customValue = null
	) {
		UncannyAutomator._core.recipe.item.actionSchedule.setSchedule(
			this.itemId,
			{
				asyncMode: asyncMode,
				delayNumber: delayNumber,
				delayUnit: delayUnit,
				scheduleTime: scheduleTime,
				scheduleDate: scheduleDate,
				scheduleSentence: sentence,
				customValue: customValue,
			}
		).then( response => {
			// Destroy modal
			this.modal.destroy();

			// Clear the cache of tokens
			UncannyAutomator._cache.tokens = [];

			new Actions();
		} ).catch( error => {
			// Destroy modal
			this.modal.destroy();

			new Actions();
		} );
	}

	removeSchedule() {
		UncannyAutomator._core.recipe.item.actionSchedule.removeSchedule(
			this.itemId,
			this.fabricatedMeta.async_mode
		).then( response => {
			// Clear the cache of tokens
			UncannyAutomator._cache.tokens = [];

			new Actions();
		} ).catch( error => {
			new Actions();
		} );
	}

	createTimeZone() {
		const timeZoneLink = $( '<a/>', {
			href: UncannyAutomator._site.links.wp_timezone,
			target: '_blank',
		} );

		const timeZoneHelpIcon = $( '<uo-icon/>', { id: 'question-circle' } );

		const timeZoneDesc = $( '<span/>', { class: 'schedule-fields__description' } ).html(
			`<strong>${ _uo.utility.escHTML( wp.i18n.__( 'Timezone', 'uncanny-automator' ) ) }</strong>: ${ UncannyAutomator._site.timezone }`
		);

		timeZoneLink.append( timeZoneHelpIcon );

		timeZoneDesc.append( timeZoneLink );

		return timeZoneDesc;
	}

	createAsyncModeHTML() {
		// Create the radio field
		this.asyncModeField = new Field( 'radio', {
			itemType: 'action',
			optionCode: 'schedule_type',
			name: 'schedule-type',
			isRequired: true,
			currentValue: this.asyncMode,
			options: [
				{
					value: 'delay',
					text: _uo.utility.escHTML( wp.i18n.__( 'Delay', 'uncanny-automator' ) ),
				},
				{
					value: 'schedule',
					text: _uo.utility.escHTML( wp.i18n.__( 'Schedule', 'uncanny-automator' ) ),
				},
				{
					value: 'custom',
					text: _uo.utility.escHTML( wp.i18n.__( 'Use a token/custom value', 'uncanny-automator' ) ),
				},
			],
		} );

		return this.asyncModeField.createFormElement().addClass( 'schedule-type-radio' );
	}

	attachModeChangeEvent() {
		// Attach an event and change the confirm button text according to selection
		this.asyncModeHTML.on( 'automator:field:change', () => {
			const selectedAsyncMode = this.asyncModeField.getValue();
			let text, showNotice;

			if ( selectedAsyncMode == 'schedule' ) {
				text = _uo.utility.escHTML( wp.i18n.__( 'Schedule', 'uncanny-automator' ) );
			} else {
				text = _uo.utility.escHTML( wp.i18n.__( 'Set delay', 'uncanny-automator' ) );
			}

			if ( ! this.hasSchedule() ) {
				if ( selectedAsyncMode == 'schedule' ) {
					this.scheduleNoticeHTML.removeClass( 'hidden' );
				} else {
					this.scheduleNoticeHTML.addClass( 'hidden' );
				}
			}

			this.modal.elements.modal.box.buttons.confirm.text( text );
		} );
	}

	createScheduleOptions() {
		const scheduleOptions = $( `<div/>`, { class: 'schedule-options' } );

		const scheduleDesc = $( '<span/>', { class: 'async-mode__description' } ).text(
			_uo.utility.escHTML( wp.i18n.__( 'Run this action at a specific date and time', 'uncanny-automator' ) )
		);

		const scheduleFields = $( '<div/>', { class: 'schedule-fields' } );

		if ( ! this.hasSchedule() ) {
			this.scheduleNoticeHTML = $( '<div/>', { class: 'schedule-notice hidden' } );
			this.scheduleNoticeHTML.text( _uo.utility.escHTML( wp.i18n.__( 'Note: If the action is triggered after the specified date, this action will run immediately.', 'uncanny-automator' ) ) );

			this.scheduleNoticeHTML.addClass( 'schedule-notice__yellow' );
		}

		scheduleOptions.append( scheduleDesc );

		scheduleFields.append( this.createScheduleDateHTML() );

		scheduleFields.append( this.createScheduleTimeHTML() );

		scheduleOptions.append( scheduleFields );

		scheduleOptions.append( this.createTimeZone() );

		scheduleOptions.append( this.scheduleNoticeHTML );

		return scheduleOptions;
	}

	createCustomOptions() {
		const $customOptions = document.createElement( 'div' );
		$customOptions.classList.add( 'uap-schedule-dialog-custom-options' );

		$customOptions.innerHTML = `
			<div class="async-mode__description">
				${ _uo.utility.escHTML( wp.i18n.__( 'Run the action after a custom delay or at a custom date and time', 'uncanny-automator' ) ) }
			</div>

			<div class="uap-schedule-dialog-custom-options__fields"></div>
		`;

		this.customTokenField = new Field( 'text', {
			itemType: 'action',
			itemId: this.itemId,
			optionCode: 'delay-use-custom-value',
			description: sprintf( 
				// translators: 1. Unix timestamp
				_uo.utility.escHTML( wp.i18n.__( 'Use tokens and/or text to enter any supported format. Examples: "Friday at 1pm", "November 9", "2 hours", Unix timestamps %1$s.', 'uncanny-automator' ) ), 
				// Link with text
				`<a href="https://automatorplugin.com/knowledge-base/how-to-use-custom-scheduling-in-wordpress-automations" target="_blank">${ _uo.utility.escHTML( wp.i18n.__( 'and more', 'uncanny-automator' ) ) } <uo-icon id="external-link"></uo-icon></a>`
			),
			isRequired: true,
			supportsTokens: true,
			currentValue: this.fabricatedMeta.
			async_custom ? this.fabricatedMeta.
			async_custom : '',
		} );

		// Create form element
		const $customTokenField = this.customTokenField.createFormElement();

		$customOptions.querySelector( '.uap-schedule-dialog-custom-options__fields' ).append( $customTokenField[0] );

		// Init libraries
		// Initilize the token selector
		this.customTokenField.initTokenSelector();
		// Initilize CodeMirror
		this.customTokenField.initCodeMirror();

		return $customOptions;
	}

	createDelayOptions() {
		const delayOptions = $( `<div/>`, { class: 'delay-options' } );

		const delayDesc = $( '<span/>', { class: 'async-mode__description' } ).text(
			_uo.utility.escHTML( wp.i18n.__( 'Delay the execution of this action for', 'uncanny-automator' ) )
		);

		const delayFields = $( '<div/>', { class: 'delay-fields' } );

		this.delayNumberHTML = this.createDelayNumberHTML();

		this.delayUnitHTML = this.createDelayUnitHTML();

		const delayFieldsDesc = $( '<span/>', { class: 'delay-fields__description' } ).text(
			_uo.utility.escHTML( wp.i18n.__( 'after completion of the triggers', 'uncanny-automator' ) )
		);

		delayFields.append( this.delayNumberHTML );

		delayFields.append( this.delayUnitHTML );

		delayFields.append( delayFieldsDesc );

		delayOptions.append( delayDesc );

		delayOptions.append( delayFields );

		return delayOptions;
	}

	createDelayNumberHTML() {
		this.delayNumberField = new Field(
			'int',
			{
				itemType: 'action',
				optionCode: 'delay-number',
				isRequired: true,
				placeholder: '10',
				supportsTokens: false,
				currentValue: this.fabricatedMeta.async_delay_number ? this.fabricatedMeta.async_delay_number : '',
			},
			true,
			this.validateDelayNumber
		);

		// Create form element
		const $delayNumberField = this.delayNumberField.createFormElement();

		$delayNumberField.addClass( 'delay-fields__number' );

		// Init Codemirror
		this.delayNumberField.initCodeMirror();

		return $delayNumberField;
	}

	createDelayUnitHTML() {
		this.delayUnitField = new Field( 'select', {
			itemType: 'action',
			optionCode: 'delay-unit',
			currentValue: this.fabricatedMeta.async_delay_unit ? this.fabricatedMeta.async_delay_unit : 'minutes',
			customClass: 'hide-this',
			supportsCustomValue: false,
			optionsShowID: false,
			isRequired: true,
			options: [
				{
					value: 'seconds',
					text: _uo.utility.escHTML( wp.i18n.__( 'Seconds', 'uncanny-automator' ) ),
				},
				{
					value: 'minutes',
					text: _uo.utility.escHTML( wp.i18n.__( 'Minutes', 'uncanny-automator' ) ),
				},
				{
					value: 'hours',
					text: _uo.utility.escHTML( wp.i18n.__( 'Hours', 'uncanny-automator' ) ),
				},
				{
					value: 'days',
					text: _uo.utility.escHTML( wp.i18n.__( 'Days', 'uncanny-automator' ) ),
				},
				{
					value: 'years',
					text: _uo.utility.escHTML( wp.i18n.__( 'Years', 'uncanny-automator' ) ),
				},
			],
		} );

		return this.delayUnitField.createFormElement().addClass( 'delay-fields__unit' );
	}

	createScheduleDateHTML() {
		// Create value field
		this.scheduleDateField = new Field( 'date', {
			itemType: 'action',
			optionCode: 'schedule-date',
			isRequired: true,
			supportsTokens: false,
			currentValue: this.fabricatedMeta.async_schedule_date ? this.fabricatedMeta.async_schedule_date : '',
			placeholder: _uo.utility.escHTML( wp.i18n.__( 'Select date', 'uncanny-automator' ) ),
		} );

		// Create form element
		const $scheduleDateField = this.scheduleDateField.createFormElement();

		$scheduleDateField.addClass( 'schedule-fields__date' );

		// Init Codemirror
		this.scheduleDateField.initFlatpickr();
		this.scheduleDateField.initCodeMirror();

		return $scheduleDateField;
	}

	createScheduleTimeHTML() {
		// Create value field
		this.scheduleTimeField = new Field( 'time', {
			itemType: 'action',
			optionCode: 'schedule-time',
			isRequired: true,
			supportsTokens: false,
			minuteIncrement: 1,
			currentValue: this.fabricatedMeta.async_schedule_time ? this.fabricatedMeta.async_schedule_time : '',
			placeholder: _uo.utility.escHTML( wp.i18n.__( 'Select time', 'uncanny-automator' ) ),
		} );

		// Create form element
		const $scheduleTimeField = this.scheduleTimeField.createFormElement();

		$scheduleTimeField.addClass( 'schedule-fields__time' );

		// Init Codemirror
		this.scheduleTimeField.initFlatpickr();
		this.scheduleTimeField.initCodeMirror();

		return $scheduleTimeField;
	}

	validateForm() {
		const asyncMode = this.asyncModeField.getValue();

		let validSchedule;

		switch ( asyncMode ) {
			case 'schedule':
				validSchedule = this.validateScheduleFields();
				break;
			case 'delay':
				validSchedule = this.delayNumberField.validate();
				break;
			case 'custom':
				validSchedule = this.customTokenField.validate();
				break;

			default:
				validSchedule = {
					isValid: false,
					message: _uo.utility.escHTML( wp.i18n.__( 'Unsupported value.', 'uncanny-automator' ) ),
				};
				break;
		}

		if ( ! validSchedule.isValid ) {
			return validSchedule;
		}

		return { isValid: true };
	}

	validateScheduleFields() {
		let validSchedule = this.scheduleDateField.validate();

		if ( validSchedule.isValid ) {
			validSchedule = this.scheduleTimeField.validate();
		}

		return validSchedule;
	}

	validateDelayNumber( value, simulate_int ) {
		if ( value < 1 ) {
			return {
				isValid: false,
				message: _uo.utility.escHTML( wp.i18n.__( 'Please use a positive number.', 'uncanny-automator' ) ),
			};
		}

		return { isValid: true };
	}

	shouldAddButton() {
		return (
			// Check if it's an action
			this.itemType == 'action' &&
			// The action is not missing
			! this.isItemMissing
		);
	}

	get isItemMissing() {
		if ( ! _uo.utility.isDefined( this.item ) ) {
			return true;
		}

		if ( _uo.utility.isDefined( this.item.isMissing ) ) {
			return this.item.isMissing;
		}

		return ! _uo.utility.isDefined( UncannyAutomator._core.directory.items.getItem(
			this.integrationID,
			this.itemType,
			this.itemCode
		) );
	}

	/**
	 * Creates the dialog that explains to non-Pro users what this feature does and how they can get it.
	 */
	handleCreateUpsellDialog() {
		// Create the node that we'll use to render the dialog
		// This node will be added as a direct child of the body node.
		// We can't add it inside the component created on this class because of z-index issues
		const $wrapper = document.createElement( 'div' );
		document.body.append( $wrapper );

		render(
			html`
				<uo-dialog
					heading=${ _uo.utility.escHTML( wp.i18n.__( 'Delay & schedule', 'uncanny-automator' ) ) }
					size="large"
					featured-image=${ delayScheduleBannerImg }
					featured-image-position="center top"
					open
				>
					<p>
						<uo-markdown 
							allowed-tags="strong"
							.content=${ _uo.utility.escHTML( wp.i18n.__( "Add **delayed** or **scheduled actions** to your recipes. With the ability to delay or schedule actions, you can run an action a specific number of **minutes, hours, or days after a user completes the recipe's triggers!**", 'uncanny-automator' ) ) }>
						</uo-markdown>
					</p>

					<p>
						${ _uo.utility.escHTML( wp.i18n.__( 'Here are a few examples of what is possible with delayed and scheduled actions:', 'uncanny-automator' ) ) }
					</p>

					<ul>
						<li>
							<uo-markdown 
								allowed-tags="strong"
								.content=${ _uo.utility.escHTML( wp.i18n.__( 'When a new user registers, **send them an onboarding drip campaign over a period of days or weeks** to help them get up to speed with minimal support', 'uncanny-automator' ) ) }>
							</uo-markdown>
						</li>

						<li>
							<uo-markdown 
								allowed-tags="strong"
								.content=${ _uo.utility.escHTML( wp.i18n.__( 'When a user purchases a product, **send them an email a week later to ask them to leave a review**.', 'uncanny-automator' ) ) }>
							</uo-markdown>
						</li>

						<li>
							<uo-markdown 
								allowed-tags="strong"
								.content=${ _uo.utility.escHTML( wp.i18n.__( 'When a user registers for an event, **send them a reminder before the event**.', 'uncanny-automator' ) ) }>
							</uo-markdown>
						</li>

						<li>
							<uo-markdown 
								allowed-tags="strong"
								.content=${ _uo.utility.escHTML( wp.i18n.__( 'When a user enrolls in a course or event, **send them supporting materials at regular intervals** during the course or before or after the event.', 'uncanny-automator' ) ) }>
							</uo-markdown>
						</li>
					</ul>

                    <p>
						${ _uo.utility.escHTML( wp.i18n.__( 'You can also use the scheduled recipe feature to run recipes at regular intervals to do things like:', 'uncanny-automator' ) ) }
					</p>

                    <ul>
						<li>
							<uo-markdown 
								allowed-tags="strong"
								.content=${ _uo.utility.escHTML( wp.i18n.__( "Send **email reminders** to users that haven't completed a key activity.", 'uncanny-automator' ) ) }>
							</uo-markdown>
						</li>

						<li>
							<uo-markdown 
								allowed-tags="strong"
								.content=${ _uo.utility.escHTML( wp.i18n.__( '**Log data for a report** in Google Sheets, AirTable or Notion.', 'uncanny-automator' ) ) }>
							</uo-markdown>
						</li>

                        <li>
							<uo-markdown 
								allowed-tags="strong"
								.content=${ _uo.utility.escHTML( wp.i18n.__( 'Perform **scheduled maintenance** on a site.', 'uncanny-automator' ) ) }>
							</uo-markdown>
						</li>
					</ul>
					
					<uo-button
						slot="primary-action"

						href=${ this.upsaleURL }
						target="_blank"

						dialog-action="close"
					>
						${ _uo.utility.escHTML( wp.i18n.__( 'Get Delays', 'uncanny-automator' ) ) }
					</uo-button>

					<uo-button
						slot="secondary-action"
						dialog-action="close"
						color="secondary"
					>
						${ _uo.utility.escHTML( wp.i18n._x( 'Cancel', 'Verb', 'uncanny-automator' ) ) }
					</uo-button>
				</uo-dialog>
			`,
			$wrapper
		);
	}

	/**
	 * The URL to the upsell page. This URL will include UTM parameters to track the user's journey.
	 *
	 * @return {String} The URL to the upsell page.
	 */
	get upsaleURL() {
		return _uo.utility.addParametersToURL(
			// Add UTM parameters
			_uo.utility.addParametersUTM( 'https://automatorplugin.com/pricing/', {
				medium: 'recipe_creator',
				content: 'add_delay_button',
			} ),
			// Add context to show banner in the pricing page
			{
				uap_bpro_context: 'delay'
			}
		)
	}
}

export default ItemHeaderAsync;
